var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZendesk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "currentColor",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "zendesk__Integration=Zendesk, Size=48",
    className: "zendesk__Integration=Zendesk, zendesk__Size=48"
  }, /*#__PURE__*/React.createElement("g", {
    id: "zendesk__Integrations",
    className: "zendesk__Integrations"
  }, /*#__PURE__*/React.createElement("path", {
    id: "zendesk__Vector",
    fill: "#03363D",
    d: "M23.163 20.064v12.272H13l10.163-12.272Zm0-4.402a5.075 5.075 0 0 1-5.076 5.076c-2.804 0-5.087-2.271-5.087-5.076h10.163Zm1.674 16.674a5.075 5.075 0 0 1 5.076-5.076 5.075 5.075 0 0 1 5.076 5.076H24.837Zm0-4.402V15.662H35L24.837 27.934Z",
    className: "zendesk__Vector"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZendesk);
export default __webpack_public_path__ + "static/media/Zendesk.a69d24bd81d0f745611b7c870ded55ee.svg";
export { ForwardRef as ReactComponent };